import { ICampaignState } from 'store/types/campaign'

export const getInitialState = (): ICampaignState => ({
  campaign: null
})
